<template>
  <v-dialog v-model="dialog" max-width="500px" persistent>
    <v-card>
      <v-card-title class="headline grey lighten-2">
        Pago realizado exitosamente
      </v-card-title>

      <v-card-text>
        <v-list dense>
          <v-list-item>
            <v-list-item-content>
              <v-list-item-title><strong>ID del Pago:</strong> {{ pago.id }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-list-item>
            <v-list-item-content>
              <v-list-item-title><strong>Nombre:</strong> {{ pago.customer_info.name }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-list-item>
            <v-list-item-content>
              <v-list-item-title><strong>Correo:</strong> {{ pago.customer_info.email }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-list-item>
            <v-list-item-content>
              <v-list-item-title><strong>Total pagado:</strong> ${{ (pago.amount / 100).toFixed(2) }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-list-item>
            <v-list-item-content>
              <v-list-item-title><strong>Estado:</strong> {{ (pago.payment_status === 'paid' ? 'PAGADO' : '') }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>
        Se aplicó su pago correctamente, se han enviado su recibo(s) a el <strong>correo proporcionado</strong>, tambien puede consultar desde su perfil.
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" @click="dialog = false">Cerrar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    pago: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      dialog: true
    }
  }
}
</script>
